<button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Add New User</h3>
<mat-dialog-content class="change-bg">
  <form [formGroup]="newUserData" *ngIf="type == 'new'">
    <mat-form-field appearance="fill">
      <mat-label >First Name</mat-label>
      <input matInput formControlName="firstName" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" placeholder="Phone number with country code."required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Division</mat-label>
      <input matInput formControlName="division" >
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Password</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="passwordCreate" (keyup)="onConformPassword($event)" required>
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
      <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error *ngIf="newUserData.get('passwordCreate').hasError('minlength')">
        Password should be atleast 6 characters long!
      </mat-error>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Confirm Password</mat-label>
      <input matInput [type]="hide1 ? 'password' : 'text'" formControlName="conformPassword" (keyup)="onConformPassword($event)" required>
      <button mat-icon-button matSuffix >
      </button>
      <mat-hint align="start" style="color: orangered;" *ngIf="(passwordMatch == 'notmatch')"><strong>Long Way To Match.</strong> </mat-hint>
      <mat-hint align="start" style="color: green;" *ngIf="(passwordMatch == 'match')"><strong>Match</strong> </mat-hint>
    </mat-form-field>
  </form>

  <form [formGroup]="updateUserData" *ngIf="type == 'edit'">
    <mat-form-field appearance="fill">
      <mat-label >First Name</mat-label>
      <input matInput formControlName="firstName" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
      <mat-label>Division</mat-label>
      <input matInput formControlName="division" >
    </mat-form-field>
    <br>
  </form>
  
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="handleCreateNewUser()" [disabled]="!newUserData.valid" color="primary" *ngIf="type == 'new'">Create</button>
  <button mat-raised-button (click)="handleUpdateUser()" [disabled]="!updateUserData.valid" color="primary" *ngIf="type == 'edit'">Save</button>
</mat-dialog-actions>
  
